<template>
  <div class="ibox">
    <div class="ibox-title text-center pb-2">
      <h1>{{ user.name }}</h1>
      <p class="text-muted">{{ user.email }}</p>
    </div>

    <div class="ibox-content">

      <!-- Informações Básicas -->
      <div class="row">
        <div class="col-md-12">
          <h3 class="mb-3">Informações Básicas</h3>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-id">ID</label>
            <input id="user-id" type="text" class="form-control" :value="user.id" disabled>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-name">Nome</label>
            <input id="user-name" type="text" class="form-control" :value="user.name" disabled>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-email">E-mail</label>
            <input id="user-email" type="email" class="form-control" :value="user.email" disabled>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-super-user">Administrador</label>
            <input id="user-super-user" type="text" class="form-control" :value="user.superUser ? 'Sim' : 'Não'"
              disabled>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-created-at">Criado em</label>
            <input id="user-created-at" type="text" class="form-control" :value="user.createdAt | datetime" disabled>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-updated-at">Atualizado em</label>
            <input id="user-updated-at" type="text" class="form-control" :value="user.updatedAt | datetime" disabled>
          </div>
        </div>
      </div>

      <hr class="my-4"/>

      <!-- Informações de Login -->
      <div class="row">
        <div class="col-md-12">
          <h3 class="mb-3">Informações de Login</h3>
        </div>

        <div class="col-md-4">
          <div class="form-group mx-3">
            <label for="user-sign-in-count">Quantidade de logins</label>
            <input id="user-sign-in-count" type="text" class="form-control" :value="user.signInCount || 0" disabled>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mx-3">
            <label for="user-current-sign-in-at">Último login</label>
            <input id="user-current-sign-in-at" type="text" class="form-control"
              :value="user.currentSignInAt ? (user.currentSignInAt | datetime) : 'Nunca'" disabled>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mx-3">
            <label for="user-last-sign-in-at">Penúltimo login</label>
            <input id="user-last-sign-in-at" type="text" class="form-control"
              :value="user.lastSignInAt ? (user.lastSignInAt | datetime) : 'Nunca'" disabled>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-current-sign-in-ip">IP do último login</label>
            <input id="user-current-sign-in-ip" type="text" class="form-control" :value="user.currentSignInIp || '-'"
              disabled>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group mx-3">
            <label for="user-last-sign-in-ip">IP do penúltimo login</label>
            <input id="user-last-sign-in-ip" type="text" class="form-control" :value="user.lastSignInIp || '-'"
              disabled>
          </div>
        </div>
      </div>

      <hr class="my-4"/>

      <!-- Botões de ação -->
      <div class="row">
        <div class="col-md-12">
          <router-link to="/admin/users" class="btn btn-outline">
            Voltar para lista
          </router-link>
          <button v-if="user.id !== getUser.id" @click="impersonate" class="btn btn-primary ml-2">
            Impersonar usuário
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import GetUser from '@/mixins/GetUser'
import { notifySessionChanged } from '@/utils/sessionChannel'
import { mapMutations } from 'vuex'

export default {
  computed: {
    userId() {
      return this.$route.params.id
    }
  },
  created() {
    const user = this.$ls.get(`adminUserShow${this.userId}`)
    if (user) {
      this.user = user
      this.setNameBreadcrumb(this.user.name)
    } else {
      this.loadUser()
    }
  },
  data: () => ({
    user: {}
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
    loadUser() {
      this.axios.get(`/admin/users/${this.userId}`)
        .then(response => {
          this.user = response.data
          this.setNameBreadcrumb(this.user.name)
          this.$ls.set(`adminUserShow${this.userId}`, this.user, { minutes: 1 })
        })
        .catch(e => {
          this.$notify.addError(e)
          this.$router.push('/admin/users')
        })
    },
    impersonate() {
      if (!confirm('Tem certeza que deseja impersonar este usuário?'))
        return

      this.$ls.clear()
      this.axios.post(`/admin/users/${this.user.id}/impersonate`)
        .then(() => {
          notifySessionChanged()
          location.href = '/'
        })
        .catch(e => this.$notify.addError(e))
    }
  },
  mixins: [GetUser],
  name: 'AdminUserShow'
}
</script>

<style scoped>
</style>
